import React, { useState } from "react";
import styled from "@emotion/styled";
import useMeasure from "react-use/lib/useMeasure";
import { buildIndexedArray } from "@ecologi/shared";
import {
  ProjectInsightsCard,
  ProjectInsightsCardProps,
} from "../ProjectInsightsCard/ProjectInsightsCard";
import { LoadMoreButton } from "./LoadMoreButton";

const PROJECT_CARD_PIXEL_WIDTH = 356;
const PROJECT_CARD_PIXEL_GAP = 24;

const ProjectsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  gap: ${PROJECT_CARD_PIXEL_GAP}px;
`;

interface SupportedProjectsProps {
  projects: ProjectInsightsCardProps[];
  maxProjectsPerPage: number;
}

export const SupportedProjects = ({
  projects,
  maxProjectsPerPage,
}: SupportedProjectsProps) => {
  const [projectsRef, { width: projectsWidth }] = useMeasure<HTMLDivElement>();
  const [numberOfVisiblePages, setNumberOfVisiblePages] = useState(1);

  const numberOfColumns = Math.floor(
    (projectsWidth - PROJECT_CARD_PIXEL_GAP) / PROJECT_CARD_PIXEL_WIDTH
  );

  const maxVisibleProjects = numberOfVisiblePages * maxProjectsPerPage;
  const visibleProjects = projects.slice(0, maxVisibleProjects);

  const numberOfEmptyCards =
    numberOfColumns > 1
      ? Math.floor(numberOfColumns - (visibleProjects.length % numberOfColumns))
      : 0;

  return (
    <>
      <ProjectsContainer ref={projectsRef}>
        {visibleProjects.length > 0 &&
          visibleProjects.map(
            (project: ProjectInsightsCardProps, index: number) => {
              return (
                <ProjectInsightsCard
                  key={`project_${index}`}
                  imageUrl={project.imageUrl}
                  size={project.size}
                  title={project.title}
                  description={project.description}
                  certifications={project.certifications}
                  projectLink={project.projectLink}
                  variant={project.variant}
                  carbonTotal={project.carbonTotal}
                />
              );
            }
          )}

        {(visibleProjects.length === 0 ||
          numberOfEmptyCards < numberOfColumns) &&
          buildIndexedArray(numberOfEmptyCards).map((index: number) => (
            <ProjectInsightsCard.Placeholder key={`placeholder_${index}`} />
          ))}
      </ProjectsContainer>
      {projects.length > maxProjectsPerPage && (
        <LoadMoreButton
          numberOfProjects={projects.length}
          numberOfVisibleProjects={visibleProjects.length}
          numberOfVisiblePages={numberOfVisiblePages}
          setNumberOfVisiblePages={setNumberOfVisiblePages}
        />
      )}
    </>
  );
};
